(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2882],{

/***/ 67483:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[slug]",
      function () {
        return __webpack_require__(20483);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/SliceZone.js + 1 modules
var SliceZone = __webpack_require__(172);
// EXTERNAL MODULE: ./src/@next/components/molecules/Breadcrumbs/index.ts + 4 modules
var Breadcrumbs = __webpack_require__(95476);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceAccordion/index.tsx + 2 modules
var SliceAccordion = __webpack_require__(87226);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceBlogContentPhotoPhoto/index.tsx + 2 modules
var SliceBlogContentPhotoPhoto = __webpack_require__(30513);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceBlogContentTextPhoto/index.tsx + 2 modules
var SliceBlogContentTextPhoto = __webpack_require__(84648);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceBlogContentTextText/index.tsx + 2 modules
var SliceBlogContentTextText = __webpack_require__(85370);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceContentPhotoText/index.tsx + 2 modules
var SliceContentPhotoText = __webpack_require__(88727);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceContentPhotoPhoto/index.tsx + 2 modules
var SliceContentPhotoPhoto = __webpack_require__(83147);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceDownloadFiles/index.ts + 5 modules
var SliceDownloadFiles = __webpack_require__(65511);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceExerpt/index.ts + 2 modules
var SliceExerpt = __webpack_require__(43539);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceFormEmbded/index.tsx + 2 modules
var SliceFormEmbded = __webpack_require__(77659);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceHtmlEmbded/index.tsx + 2 modules
var SliceHtmlEmbded = __webpack_require__(18789);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceHeroImg/index.ts + 2 modules
var SliceHeroImg = __webpack_require__(75386);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceIconBanner/index.ts + 2 modules
var SliceIconBanner = __webpack_require__(719);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceIconCta/index.ts + 2 modules
var SliceIconCta = __webpack_require__(37505);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceImageCta/index.tsx + 2 modules
var SliceImageCta = __webpack_require__(70872);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceImageCards/index.ts + 2 modules
var SliceImageCards = __webpack_require__(71373);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceLinkButton/index.ts + 2 modules
var SliceLinkButton = __webpack_require__(80279);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceMediaSlider/index.ts + 2 modules
var SliceMediaSlider = __webpack_require__(18761);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceOurPartners/index.ts + 2 modules
var SliceOurPartners = __webpack_require__(29848);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceQuote/index.ts + 3 modules
var SliceQuote = __webpack_require__(67293);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceRelatedProducts/index.tsx + 2 modules
var SliceRelatedProducts = __webpack_require__(65395);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceRichText/index.ts + 2 modules
var SliceRichText = __webpack_require__(34912);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceTagImage/index.ts + 2 modules
var SliceTagImage = __webpack_require__(88329);
;// CONCATENATED MODULE: ./src/views/PrismicPage/Slices.ts

// import { SliceArchitectReviews } from '@components/slices/SliceArchitectReviews';
// import { SliceBenefits } from '@components/slices/SliceBenefits';
// import { SliceBenefitsProgram } from '@components/slices/SliceBenefitsProgram';





// import { SliceCollections } from '@components/slices/SliceCollections';
// import { SliceColorSample } from '@components/slices/SliceColorSample';
// import { SliceConsultToolbox } from '@components/slices/SliceConsultToolbox';
// import { SliceCta } from '@components/slices/SliceCta';




// import { SliceFranchiseContact } from '@components/slices/SliceFranchiseContact';





// import { SliceInspiration } from '@components/slices/SliceInspiration';
// import { SliceInstagramPosts } from '@components/slices/SliceInstagramPosts';
// import { SliceLabeledIcons } from '@components/slices/SliceLabeledIcons';



// import { SliceProductDetails } from '@components/slices/SliceProductDetails';
// import { SliceProductFeatures } from '@components/slices/SliceProductFeatures';

// import { SliceRelatedPagesSlider } from '@components/slices/SliceRelatedPagesSlider';

// import { SliceReviews } from '@components/slices/SliceReviews';

// import { SliceShowRoom } from '@components/slices/SliceShowRoom';

// import { SliceTrusted } from '@components/slices/SliceTrusted';
var components = {
    accordion: SliceAccordion/* SliceAccordion */.C,
    //  architectreviews: SliceArchitectReviews,
    //  benefits: SliceBenefits,
    //  benefitsprogram: SliceBenefitsProgram,
    //  collections: SliceCollections,
    //  color_sample: SliceColorSample,
    //  consulttoolbox: SliceConsultToolbox,
    content_photo_photo_50: SliceBlogContentPhotoPhoto/* SliceBlogContentPhotoPhoto */.F,
    content_photo_text_30_60: SliceBlogContentTextPhoto/* SliceBlogContentTextPhoto */.i,
    content_text_photo_60_30: SliceBlogContentTextPhoto/* SliceBlogContentTextPhoto */.i,
    content_text_text_50: SliceBlogContentTextText/* SliceBlogContentTextText */.z,
    content_photo_text: SliceContentPhotoText/* SliceContentPhotoText */.D,
    content_photo_photo: SliceContentPhotoPhoto/* SliceContentPhotoPhoto */.w,
    //  cta: SliceCta,
    downloadfiles: SliceDownloadFiles/* SliceDownloadFiles */.H,
    excerpt: SliceExerpt/* SliceExerpt */.V,
    formembded: SliceFormEmbded/* SliceFormEmbded */.I,
    htmlembded: SliceHtmlEmbded/* SliceHtmlEmbded */.z,
    // franchisecontact: SliceFranchiseContact,
    heroimg: SliceHeroImg/* SliceHeroImg */.U,
    iconbanner: SliceIconBanner/* SliceIconBanner */.A,
    iconcta: SliceIconCta/* SliceIconCta */.B,
    imagecta: SliceImageCta/* SliceImageCta */.g,
    imagecard: SliceImageCards/* SliceImageCards */.a,
    //  inspiration: SliceInspiration,
    //  instagram_posts: SliceInstagramPosts,
    //  labeled_icons: SliceLabeledIcons,
    linkbutton: SliceLinkButton/* SliceLinkButton */.T,
    mediaslider: SliceMediaSlider/* SliceMediaSlider */.N,
    ourpartners: SliceOurPartners/* SliceOurPartners */.I,
    //  product_details: SliceProductDetails,
    //  product_features: SliceProductFeatures,
    quote: SliceQuote/* SliceQuote */.I,
    // relatedpagesslider: SliceRelatedPagesSlider,
    relatedproducts: SliceRelatedProducts/* SliceRelatedProducts */.k,
    //  reviews: SliceReviews,
    richtext: SliceRichText/* SliceRichText */.c,
    //  showroom: SliceShowRoom,
    tagimage: SliceTagImage/* SliceTagImage */._
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/views/PrismicPage/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slice-item {\n    margin: 2em auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject());
var Content = globalStyles/* styled.div */.zo.div(_templateObject1());

;// CONCATENATED MODULE: ./src/views/PrismicPage/Page.tsx






var Page = function(param) {
    var content = param.content, breadcrumbs = param.breadcrumbs;
    var body = content.body, showbreadcrumbs = content.showbreadcrumbs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "prismic-page",
        children: [
            showbreadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
                breadcrumbs: breadcrumbs,
                useMediaQueries: false,
                showHomeLink: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                    slices: body,
                    components: components
                })
            })
        ]
    });
};
Page.displayName = "PrismicPage";
/* harmony default export */ var PrismicPage_Page = (Page);

;// CONCATENATED MODULE: ./src/views/PrismicPage/View.tsx







var View = function(param) {
    var page = param.page, seo = param.seo, slug = param.params.slug;
    var breadcrumbs = [
        {
            link: "/",
            value: "Home"
        },
        {
            link: (0,core/* generatePath */.Gn)(paths/* paths.page */.H.page, {
                slug: slug
            }),
            value: slug.replace(/-/g, " ")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicPage_Page, {
                content: page,
                breadcrumbs: breadcrumbs
            })
        ]
    });
};
View.displayName = "PrismicPageView";
/* harmony default export */ var PrismicPage_View = (View);

;// CONCATENATED MODULE: ./src/views/PrismicPage/index.tsx


;// CONCATENATED MODULE: ./src/pages/page/[slug].ts

var __N_SSG = true;
/* harmony default export */ var _slug_ = (PrismicPage_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,3537,7453,3955,9434,2394,9774,2888,179], function() { return __webpack_exec__(67483); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);